import { Color, Paragraph } from '@eggplant/pattern-library'

const description = `To ensure all requirements (the entire file) are imported, we recommend verifying all the cells in the 

requirement ID and description columns are in the correct format.`

const RequirementsWarningTip = () =>
  <Paragraph>
    <Color variant='theme-description-text'>
      {description}
    </Color>
  </Paragraph>

export default RequirementsWarningTip
